<template>
<div>
    <Modal
        class-name="vertical-center-modal"
        :value="showModel"
        :title="title"
        :footer-hide="true"
        :mask-closable="false"
        @on-cancel="cancel"
        @on-visible-change="openOrClose"  :styles="{'min-width':'700px'}">
        
        <Form ref="formData" :model="formData" :rules="ruleCustom" :label-width="80">

            <FormItem :label="$t('BasicProduct.funcBox.titleName.Name')" prop="nikeName" style="width: 500px">
                <Input  v-model.trim="formData.nikeName"  :placeholder="$t('inputPlaceholder')" ></Input>
            </FormItem>

            <FormItem :label="$t('userManage.emailAddress')" :class="formData.signUpOptions==1?'ivu-form-item-required':''" prop="email"  style="width: 500px;">
                <Input type="text" v-model.trim="formData.email" :placeholder="$t('inputPlaceholder')"></Input>
            </FormItem>


            <FormItem v-if="type==2" :label="$t('setting.resetPassword')" style="width: 500px">
                <span  v-if="forcePass"  style="margin-right:20px">{{ forcePass }}</span>
                <template v-if="roleType==2">
                    <Poptip confirm :title="$t('setting.resetPasswordTipOne')" :ok-text="$t('confirm')" :cancel-text="$t('cancel')"
                        @on-ok="resetLoginPwd">
                        <Button type="info" ghost :loading="resetLoginPwdDisabled" size="small" style="line-height:normal">{{ $t('setting.reset')
                        }}</Button>
                    </Poptip>
                </template>
            </FormItem>

            <FormItem>
                <Button :loading="disabled"  type="primary" @click="subData('formData')" style="margin-right:20px">{{$t('save')}}</Button>
                <Button :disabled="disabled" @click="cancel">{{$t('cancel')}}</Button>
            </FormItem>
        </Form>

    </Modal>
</div>
</template>
<script>
/**
 * 弹框
 * @param showModel boolean 对话框开关 true false
 * @param fn function 回调函数
 * @param type Number 类型 1添加 2编辑
 * @param editFormData Object 编辑时的数据
 */
import common from '@/common/common';
import SearchSelectRecycle from '@/views/userManage/component/selectListCountry.vue';
import { mapState } from 'vuex'
import qs from 'qs'
    export default {
        props: {
            showModel: Boolean,
            fn:Function,
            type:Number,
            editFormData:Object
        },
        name: "AddUserModel",
        components: {
            SearchSelectRecycle
        },
        data() {
            return {   
                disabled: false,//禁用确定按钮
                title: '',//弹框标题
                forcePass: "",
                resetLoginPwdDisabled:false,
                formData: {//表单数据
                   id:'',
                   email:'',
                   nikeName:''
                }, 
                
            }
        },
       
        computed:{
            ...mapState(["local", "selectId"]),
            roleType(){
	        	 let res = '3'
	        	 if(this.$store.state.uInfo && this.$store.state.uInfo.roleType){
	        		 res = this.$store.state.uInfo.roleType
	        	 }
	        	 return res
	         },
            ruleCustom(){
                return {//验证
                    email: [
                        { required: true, message:this.$t('required'),trigger: 'blur' },
                        {
                            pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                            message: this.$t('ruleCustom.email'),
                            trigger: 'blur'
                        }
                    ],
                    nikeName: [
                        { required: true, message:this.$t('required'),trigger: 'blur' },
                    ]
                }
            }

        },
        created(){
            
        },
        methods: {
            resetLoginPwd() {//重置登录密码
                this.resetLoginPwdDisabled = true
                this.axios.post(this.config.urlArray.forceResetPassword, { 
                id: this.formData.id,
                // language:this.formData.language
                 }).then((result) => {
                    common.ajaxMsg(result.data, true, () => {
                        this.forcePass = result.data.data.forcePass
                    })
                }).finally(()=>{
                    this.resetLoginPwdDisabled = false
                })
            },
            openOrClose(value) {
                if(value === true) {    
                    this.title =this.type==1? this.$t('userManage.addUserModel.title'): this.$t('userManage.addUserModel.title1')

                    if(this.type==2){
                        console.log('this.editFormData',this.editFormData)
                        for (let key in this.editFormData) {
                            if (this.formData.hasOwnProperty(key)) {
                                this.formData[key] = this.editFormData[key]
                            }
                        }
                        this.forcePass = this.editFormData.forcePass
                    }

                   
                } else { //关闭弹框后要做的处理
                    this.resetForm();//重置表单
                    // this.$refs.countryRef.clearVal()
                }
            },
            subData(name) {//提交表单
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        this.disabled = true;
                      
                        let params ={
                            ...this.formData
                        }
                        
                        if(this.type==1) delete params.id

                        let url = this.type==1?this.config.urlArray.createInstaller:this.config.urlArray.updateInstaller
                       
                        this.axios.post(url, params).then((result) => {
                            common.ajaxMsg(result.data,true,()=>{//提交表单后的回调处理
                                this.resetForm();//重置表单
                                this.fn()
                            },()=>{this.disabled = false; })
                            
                        }).catch((err) => {
                            common.msg('error','提交失败',()=>{this.disabled = false;})
                        });
                        
                    }
                })
            },
            cancel() {//对话框关闭
                this.$emit('update:showModel',false);
            },
            resetForm() {//重置表单
                this.$refs.formData.resetFields();//重置表单
                this.disabled = false;//恢复提交按钮为激活状态
                Object.keys(this.formData).forEach(key=>{this.formData[key]=''})
                this.forcePass=''
            }
        }
    }
</script>

<style lang="less" scoped>
/deep/ .vertical-center-modal{
    display: flex;
    align-items: center;
    justify-content: center;
    .ivu-modal{
        top: 0;
    }
   
}
</style>
